<template>
  <div class="w-full max-w-none">
    <RouterView></RouterView>
  </div>
</template>
